import React from "react";
import { styled } from "@mui/material";
// assets
import imgPoweredByPayPal from "../../../images/icon/ic-powered_by_paypal.svg";

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "4rem",
  paddingBottom: "2.5rem",
  "> img": {
    objectFit: "scale-down",
    height: "auto",
    width: "140px",
  },
  [theme.breakpoints.up("sm")]: {
    "> img": {
      width: "180px",
    },
  },
}));

const ImageFooter = () => {
  return (
    <Container>
      <img src={imgPoweredByPayPal} alt="Powered by PayPal" />
    </Container>
  );
};

export default ImageFooter;
